module.exports = __webpack_public_path__ + "static/media/bulk.058497fd.svg";